import { motion } from "framer-motion";
import PropTypes from "prop-types";
import { useId } from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  width: fit-content;
    max-width: 100%;
  border-radius: 999px;
  padding: 0.3rem;
  background: linear-gradient(180deg, #eff1f4 0%, #e7ebf0 100%);
  box-shadow: inset 0 1px 1px rgba(255, 255, 255, 0.85),
    inset 0 -1px 0 rgba(12, 18, 28, 0.05);
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
        display: none;
    }

  .track {
    display: flex;
    align-items: center;
    gap: 0.2rem;
    position: relative;
        width: max-content;
  }

  .segment {
    border: none;
    background: transparent;
    color: #657083;
    font-weight: 600;
    font-size: 0.9rem;
    line-height: 1;
    border-radius: 999px;
    padding: 0.65rem 1.05rem;
    cursor: pointer;
    position: relative;
    z-index: 1;
    transition: color 0.2s ease;
    white-space: nowrap;
  }

  .segment:hover {
    color: #3f4b5f;
  }

  .segment.active {
    color: #151c28;
  }

  .segment:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }

  .active-pill {
    position: absolute;
    top: 0.1rem;
    bottom: 0.1rem;
    left: 0;
    right: 0;
    border-radius: 999px;
    background: #ffffff;
    box-shadow: 0 1px 2px rgba(12, 18, 28, 0.06), 0 8px 16px rgba(12, 18, 28, 0.07);
  }

    @media (max-width: 480px) {
        padding: 0.22rem;

        .segment {
            font-size: 0.82rem;
            padding: 0.55rem 0.8rem;
        }
    }

    @media (max-width: 360px) {
        .segment {
            font-size: 0.76rem;
            padding: 0.48rem 0.65rem;
        }
    }
`;

const StandardSlidingPillNav = ({ options, active, onChange, className }) => {
    const layoutId = useId();

    return (
        <Wrapper className={className}>
            <div className="track" role="tablist" aria-label="View switcher">
                {options.map((option) => {
                    const isActive = option.value === active;

                    return (
                        <button
                            key={option.value}
                            type="button"
                            role="tab"
                            aria-selected={isActive}
                            disabled={option.disabled}
                            className={`segment ${isActive ? "active" : ""}`}
                            onClick={() => {
                                if (!option.disabled && option.value !== active) {
                                    onChange(option.value);
                                }
                            }}
                        >
                            {isActive && (
                                <motion.div
                                    layoutId={layoutId}
                                    className="active-pill"
                                    transition={{
                                        type: "spring",
                                        stiffness: 450,
                                        damping: 38,
                                        mass: 0.55,
                                    }}
                                />
                            )}
                            <span>{option.label}</span>
                        </button>
                    );
                })}
            </div>
        </Wrapper>
    );
};

StandardSlidingPillNav.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired,
            disabled: PropTypes.bool,
        })
    ).isRequired,
    active: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
};

StandardSlidingPillNav.defaultProps = {
    className: "",
};

export default StandardSlidingPillNav;
